export default __webpack_public_path__ + "static/media/messagenotification.9469be4d.svg";